import { render } from "./PrivacyBanner.vue?vue&type=template&id=00d9709a&scoped=true"
import script from "./PrivacyBanner.vue?vue&type=script&lang=js"
export * from "./PrivacyBanner.vue?vue&type=script&lang=js"

import "./PrivacyBanner.vue?vue&type=style&index=0&id=00d9709a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d9709a"]])

export default __exports__